export function applyFlag(flags, key, value) {
  return {
    ...flags,
    [key]: value,
  };
}

export function removeFlag(flags, key) {
  const updatedFlags = { ...flags };
  delete updatedFlags[key];
  return updatedFlags;
}
